import { render, staticRenderFns } from "./FilterDetails.vue?vue&type=template&id=357ebaed&"
import script from "./FilterDetails.vue?vue&type=script&lang=js&"
export * from "./FilterDetails.vue?vue&type=script&lang=js&"
import style0 from "./FilterDetails.vue?vue&type=style&index=0&id=357ebaed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports